import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <div className="footer-content">
        <div>
          <img 
            src="/artcardo-logo.png" 
            alt="ARTCARDO Logo" 
            style={{height: '200px', width: 'auto', marginBottom: '1rem'}}
          />
          <p className="text-sm opacity-80">
            Connecting independent artists & artisans with art lovers worldwide.
            Discover unique handcrafted pieces from talented artisans.
          </p>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/products" className="opacity-80 hover:opacity-100">Products</Link></li>
            <li><Link to="/artists" className="opacity-80 hover:opacity-100">Artists</Link></li>
            <li><Link to="/about" className="opacity-80 hover:opacity-100">About Us</Link></li>
            <li><Link to="/contact" className="opacity-80 hover:opacity-100">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">For Artists</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="opacity-80 hover:opacity-100">Become a Seller</Link></li>
            <li><Link to="/artist-dashboard" className="opacity-80 hover:opacity-100">Seller Dashboard</Link></li>
            <li><Link to="/artist-support" className="opacity-80 hover:opacity-100">Artist Support & Help</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy-policy" className="opacity-80 hover:opacity-100">Privacy Policy</Link></li>
            <li><Link to="/buyer-terms" className="opacity-80 hover:opacity-100">Terms & Conditions</Link></li>
            <li><Link to="/returns-refunds" className="opacity-80 hover:opacity-100">Returns & Refunds</Link></li>
            <li><Link to="/buyer-protection" className="opacity-80 hover:opacity-100">Buyer Protection</Link></li>
            <li><Link to="/data-protection" className="opacity-80 hover:opacity-100">Data Protection</Link></li>
            <li><Link to="/legal-disclaimers" className="opacity-80 hover:opacity-100">Legal Disclaimers</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Connect With Us</h4>
          <div className="flex gap-3 mb-3">
            <a href="#" className="opacity-80 hover:opacity-100"><Facebook className="w-5 h-5" /></a>
            <a href="#" className="opacity-80 hover:opacity-100"><Instagram className="w-5 h-5" /></a>
            <a href="#" className="opacity-80 hover:opacity-100"><Twitter className="w-5 h-5" /></a>
            <a href="mailto:dulciaart@gmail.com" className="opacity-80 hover:opacity-100"><Mail className="w-5 h-5" /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 ARTCARDO. All rights reserved. | <Link to="/buyer-terms" className="opacity-80 hover:opacity-100">Terms of Use</Link> | <Link to="/privacy-policy" className="opacity-80 hover:opacity-100">Privacy Policy</Link></p>
        <p className="mt-2" style={{fontSize: '0.95rem', fontWeight: '500'}}>A DULCIA.ART initiative</p>
      </div>
    </footer>
  );
};

export default Footer;